import {createAsyncThunk} from "@reduxjs/toolkit";
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
    getProducts as getProductDataApi,
    createProduct as createProductApi,
    deleteProducts as deleteProductsApi,
    getProductById as getProductByIdApi,
    updateProduct as updateProductApi,
} from "../../helpers/helper";

export const getProductData = createAsyncThunk("product/getProductDataApi", async (data:any) => {
    const {searchData, pagination} = data
    try {
        const response = await getProductDataApi(searchData, pagination);
        return response;
    } catch (error) {
        return error;
    }
});

export const createProduct = createAsyncThunk("product/createProduct", async (product: any) => {
    try {
        const response = await createProductApi(product);
        toast.success("Product Added Successfully", {autoClose: 2000});
        return response;
    } catch (error) {
        toast.error("Product Added Failed", {autoClose: 2000});
        return error;
    }
});

export const updateProduct = createAsyncThunk("product/updateProduct", async (product: any) => {
    try {
        const {formData, id} = product;
        const response = await updateProductApi(formData, id);
        toast.success("Product Added Successfully", {autoClose: 2000});
        return response;
    } catch (error) {
        toast.error("Product Added Failed", {autoClose: 2000});
        return error;
    }
});

export const deleteProduct = createAsyncThunk("product/deleteProducts", async (id: any) => {
    try {
        const response = deleteProductsApi(id);
        toast.success("Product Deleted Successfully", { autoClose: 2000 });
        return id;
    } catch (error) {
        toast.error("Product Deleted Failed", { autoClose: 2000 });
        return error;
    }
});

export const getProductById = createAsyncThunk("product/getProductById", async (id:any) => {
    try {
        const response =  getProductByIdApi(id);
        return response;
    } catch (error) {
        return error;
    }
});












